<div class="container-fluid mt-4">

  <div class="d-flex justify-content-between mb-3">
    <h4> <i class="fi fi-rr-admin-alt"></i> ადმინების სია</h4>
 
     <!-- დამატება -->
     <button class="btn btn-primary " (click)="openModalForAdd()">დამატება</button>

  </div>

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <!-- Error Message -->
  <div *ngIf="error" class="alert alert-danger">
    მოხდა შეცდომა ადმინის სიის მიღებისას.
  </div>

  <!-- Tickets Table -->
   <div class="table-responsive">
    <table *ngIf="!load && !error && data?.length > 0" class="table table-hover table-bordered mt-3">
      <thead >
        <tr>
          <th>#</th>
          <th>სახელი</th>
          <th>გვარი</th>
          <th>მომხმარებელი</th>
          <th>უფლება</th>
          <th>პარამეტრები</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of data; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.lastname }}</td>
          <td>{{ user.user }}</td>
          <td>{{ user.role }}</td>
          <td>
              <!-- რედაქტირება -->
              <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="openEditAdminModal(user)">
                    <i class="fi fi-rr-pencil"></i>
                </button> 
          
                <button type="button" class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2"
                      (click)="confirmDelete(user)">
                      <app-spinner *ngIf="deleteUserId === user.id" [sm]="true" [loading]="true"></app-spinner>
                      <i *ngIf="deleteUserId !== user.id" class="fi fi-rr-trash"></i>
                </button>        
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data -->
  <div *ngIf="!load && !error && data?.length === 0" class="alert alert-warning">
    ადმინები ვერ მოიძებნა.
  </div>



</div>





<!-- მომხმარებლის რედაქტირების მოდალი -->
<ng-template #editAdminModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ადმინის რედაქტირება</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">

      <div class="form-floating mb-3" id="name">
        <input type="text" formControlName="name" class="form-control" />
        <label for="name">სახელი</label>
      </div>

      <div class="form-floating mb-3" id="lastname">
        <input type="text" formControlName="lastname"  class="form-control" />
        <label for="lastname">გვარი</label>
      </div>

      <div class="form-floating mb-3" id="user">
        <input type="text" formControlName="user" class="form-control" />
        <label for="user">მომხმარებელი</label>
      </div>

      <div class="form-floating mb-3" id="password">
        <input type="password" formControlName="password" class="form-control" />
        <label for="password">პაროლი</label>
      </div>

      <div class="form-floating mb-3">
        <select formControlName="role" class="form-select" id="role">
          <option value="admin">ადმინი</option>
          <option value="manager">მენეჯერი</option>
        </select>
        <label for="role">როლი</label>
      </div>

      <div *ngIf="form.get('role').value === 'manager' || (form.get('role').valueChanges | async) === 'manager'">
        <div class="mb-3">
          <label class="form-label">უფლებები</label>
          <!-- <div>
            <input type="checkbox" value="main" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('main')" /> მთავარი გვერდი
          </div> -->
           <div>
            <input type="checkbox" value="menu" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('menu')" /> მენიუ
          </div>
          <div>
            <input type="checkbox" value="pages" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('pages')" /> გვერდები
          </div>
          <div>
            <input type="checkbox" value="posts" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('posts')" /> სტატიები
          </div>
          <div>
            <input type="checkbox" value="slider" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('slider')" /> სლაიდი
          </div>
          <div>
            <input type="checkbox" value="categories" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('categories')" /> კატეგორიები
          </div>
          <div>
            <input type="checkbox" value="admins" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('admins')" /> ადმინები
          </div>
          <div>
            <input type="checkbox" value="settings" (change)="onPermissionChange($event)" [checked]="form.value.permission?.includes('settings')" /> პარამეტრები
          </div>
        </div>

        <div *ngIf="form.value.permission?.includes('posts') && postCategoriesList?.length > 0">
        <label>სტატიები</label>
        <div *ngFor="let cat of postCategoriesList">
          <input 
            type="checkbox" 
            [value]="cat.menutype" 
            (change)="onPostCategoryChange($event)"
            [checked]="form.value.postCategories?.includes(cat.menutype.toString())"
          />
          {{ cat.title }}
        </div>
      </div>
    
      </div>

      

    </form>

 
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="submitEditAdmin(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner>
       შენახვა
    </button>
  </div>
</ng-template>